import script from "./ed-organism-user-profile.vue?vue&type=script&setup=true&lang=js"
export * from "./ed-organism-user-profile.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__